// extracted by mini-css-extract-plugin
export default {"container":"Collapse_container__2+e-m","stile":"Collapse_stile__t+RA4","bodyCon":"Collapse_bodyCon__yFFdM","perso":"Collapse_perso__z1mgf","butoon":"Collapse_butoon__cHFn+"};